module.exports = __webpack_public_path__ + "media/icons/Group-127902cb.png";